import React from 'react';
import { func, string } from 'prop-types';
import { PrsButton } from '../../../styles-and-themes/styles/prsButtons';
import {
  EmailVerificationContainer,
  EmailVerificationTitle,
  EmailVerificationMessage,
} from './EmailVerificationPanelStyles';

const EmailVerificationPanel = ({ userEmail, onGoToLogin }) => {
  return (
    <EmailVerificationContainer>
      <EmailVerificationTitle>Check Your Email</EmailVerificationTitle>
      <EmailVerificationMessage>
        We&apos;ve sent a verification email to <strong>{userEmail}</strong>.
        Please click the link in the email to continue your registration.
        <br /><br />
        If you don&apos;t receive the email or encounter any issues, please try logging in again.
      </EmailVerificationMessage>
      <div style={{ marginTop: '20px' }}>
        <PrsButton onClick={onGoToLogin}>
          Go to Login
        </PrsButton>
      </div>
    </EmailVerificationContainer>
  );
};

EmailVerificationPanel.propTypes = {
  userEmail: string.isRequired,
  onGoToLogin: func.isRequired,
};

export default EmailVerificationPanel;